export default "__VITE_ASSET__CMVU4ZiF__"